export const hasAll = (what, where) => {
	const hash = where.reduce((acc, i) => {
		acc.set(i, true);
		return acc;
	}, new Map());
	return what.every(i => hash.get(i));
};
